import { render, staticRenderFns } from "./BasePercent.vue?vue&type=template&id=7336a61f&"
import script from "./BasePercent.vue?vue&type=script&lang=js&"
export * from "./BasePercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports